import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { AnalyticsDataService, AnalyticsEnvironmentService } from '@monorepo/services';
import { TAnalyticsEnvironmentVars } from '@monorepo/types';
import { ChartingModule, UiModule } from '@monorepo/ui';
import { AnalyticsCardComponent } from './analytics-card/analytics-card.component';
import { AnalyticsComponentHostComponent } from './analytics-component-host/analytics-component-host.component';
import { AnalyticsContainerComponent } from './analytics-container/analytics-container.component';
import { ChartTabsComponent } from './chart-tabs/chart-tabs.component';
import { AnalyticsConfigResolverService } from './services/analytics-config-resolver.service';
import { AnalyticsFacade } from './services/analytics.facade';
import { StatTileGroupComponent } from './stat-tile-group/stat-tile-group.component';

@NgModule({
  imports: [UiModule, ChartingModule, CommonModule, IonicModule],
  declarations: [
    AnalyticsContainerComponent,
    AnalyticsComponentHostComponent,
    AnalyticsCardComponent,
    StatTileGroupComponent,
    ChartTabsComponent,
  ],
  exports: [AnalyticsContainerComponent],
})
export class AnalyticsModule {
  static forRoot(analyticsEnvironment: TAnalyticsEnvironmentVars): ModuleWithProviders<AnalyticsModule> {
    return {
      ngModule: AnalyticsModule,
      providers: [
        AnalyticsEnvironmentService,
        AnalyticsDataService,
        AnalyticsFacade,
        AnalyticsConfigResolverService,
        {
          provide: 'analyticsEnvironment',
          useValue: analyticsEnvironment,
        },
      ],
    };
  }
}
